
<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <p class="w-full mt-4"> Date
        <datepicker :inline="false" v-model="dataDate"></datepicker>
        </p>
        
          <vs-alert color="warning" title="Information" active="true" class="mt-8">
           All operations before and including today, {{ getDateFormat(dataDate) }}, will no longer be editable.<br/>
           It will be possible to add any 'Reception' but impossible to add any 'Sale' or 'Transformation'.
          </vs-alert>
      </div>
      <div class="vx-col md:w-1/2 w-full">
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
         <vs-button class="ml-8" color="success" @click="save_changes(false)" :disabled="!validateForm">Next Step</vs-button>
        </div>
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
import moduleOperationList from '@/store/operation/moduleOperationList.js'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import axios from '@/axios.js'
import moment from 'moment'

export default {
  components: {
    vSelect,
    Datepicker
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isMounted: false,
      // Data Sidebar
      buttonSubmitOpen: false,
      state:{},
      dataDate: '',
      dataOperationCategory:'4',
      successlock: true,
      maxdateoperation : ''
    }
    
  },
  computed: {
    validateForm () {
      return !this.errors.any() && (this.dataDate && this.dataOperationCategory)
    },
    currentPage () {
      if (this.isMounted) {
        if (this.data_local.id) return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      if (this.data_local.id) return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    }
  },
  methods: {
    getDateFormat(date)
    {
       return moment(date).format('DD MMMM YYYY')
    },
    getMaxInventoryDate()
    {
        var dateStop = moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD')
        axios.get('/getmaxinventorydate')
          .then((response) => {
            this.maxdateoperation = response.data
          })
    },
    lockOperation()
    {
        var dateStop = moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD')
        axios.get('/lockoperation/'+dateStop)
          .then((response) => {
            if (response) this.successlock = true
          })
    },
    save_changes () {
      if (this.maxdateoperation)
      {
        if (moment(this.maxdateoperation).add(12, 'hours') >= moment(this.dataDate))
        {
          this.$vs.notify({
            color: 'danger',
            title: 'Wrong Date!',
            text: 'Inventory already done Today!'
          })
          return
        }
      }
      this.lockOperation()
      if (this.successlock)
      {
        const obj = {
          date: moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD hh:mm:ss+02'),
          operationcategory: this.dataOperationCategory,
          isactive: true
        }
        {
          this.$store.dispatch('operationList/createOperation', obj)
          .then(response =>
            {
            this.$vs.notify({
              color: 'success',
              title: '',
              text: 'Operation Correctly Started!'
            })
            this.$router.push({path:'/inventory/' + this.$store.state.operationList.operation.id})
            }
          )        
          .catch(err => { 
          this.$vs.notify({
            color: 'alert',
            title: 'An Error Occured!',
            text: 'The operation was NOT added, please contact your dev'
          }) })
        }
      }
      else
      {
          this.$vs.notify({
            color: 'alert',
            title: 'An Error Occured!',
            text: 'The operation was NOT added, please contact your dev'
          })
      }
    }
  },
  mounted () {
    this.isMounted = true
  },
  created() {
    this.dataDate = moment().format("D MMM yyyy");
    this.getMaxInventoryDate()
  }
}
</script>

